module.exports = __webpack_public_path__ + "img/smart-scan-5.1320bbaf.png";